/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.response-dialog[_ngcontent-%COMP%] {\n  padding: 0 20px 20px 20px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9jaHJvbm9jYXNoVjMvdGVzdC93ZWJhcHAtY2xrL3NyYy9hcHAvc2hhcmVkL2NvbXBvbmVudHMvcmVzcG9uc2UtZGlhbG9nL3Jlc3BvbnNlLWRpYWxvZy5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvY2hyb25vY2FzaFYzL3Rlc3Qvd2ViYXBwLWNsay9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3Jlc3BvbnNlLWRpYWxvZy9yZXNwb25zZS1kaWFsb2cuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/shared/components/response-dialog/response-dialog.component.scss.shim.ngstyle.ts